type Translate = (key: string, values?: Record<string, string | number>) => string;

const GROUP_KEYS: Record<string, string> = { '1': 'roadway', '2': 'mixed', '3': 'severe', '4': 'special' };

const GROUP_VALUE_BY_NAME: Record<string, string> = { RODOVIARIO: '1', MISTO: '2', SEVERO: '3', ESPECIAL: '4' };

export const normalizeMaintenanceGroup = (value?: string) => {
    if (!value || value === '-') {
        return '-';
    }
    return GROUP_VALUE_BY_NAME[value] ?? value;
};

export const getMaintenanceGroupName = (t: Translate, value?: string) => {
    const normalized = normalizeMaintenanceGroup(value);
    if (normalized === '-') {
        return t('maintenanceGroup.undefined');
    }
    const key = GROUP_KEYS[normalized];
    return key ? t(`maintenanceGroup.${key}`) : (value ?? normalized);
};
